// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_CheckQrcodeUniqueInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /so/orders/check_qrcode_unique?qrcode={qrcode}&order_item_id={id}
 *
 * Live single-QR uniqueness probe for the OS-item wizard. Read from the query
 * string so a scanned QR (which may contain slashes/spaces/symbols) survives
 * URL-encoding intact.
 *
 * Fields:
 *   qrcode        — string, required (controller trims and rejects empty).
 *   order_item_id — int, optional; present only on EDIT of an existing item, to
 *                   exclude the item itself from the collision check.
 *   order_id      — int, optional; the order the new item is being added to, so
 *                   ADD scopes to the SAME franchise EDIT does. Without it the
 *                   ADD path fell back to the session filter, which refused
 *                   outright when nothing was selected ("Nenhuma franquia
 *                   selecionada no filtro") and, with several franchises
 *                   selected, rejected a QR that only collided in a neighbour's
 *                   (2026-08-25).
 *
 * Franchise scope is NEVER accepted from the client — the client names an ORDER
 * (or an item); the server reads the franchise off that row.
 */
import { registerContract } from './validate'

export interface Orders_CheckQrcodeUniqueInput {
qrcode?: string
order_item_id?: number
order_id?: number
}

registerContract('Orders_CheckQrcodeUniqueInput', {
  qrcode:        { type: 'string',  required: false },
  order_item_id: { type: 'number',  required: false },
  order_id:      { type: 'number',  required: false },
})
